export default __webpack_public_path__ + "static/logo-ks-f7045d64c620f5bd4ad42b4e4f767e81.svg";